import { render, staticRenderFns } from "./EndedServiceEmployees.vue?vue&type=template&id=560e50ab&scoped=true"
import script from "./EndedServiceEmployees.vue?vue&type=script&lang=js"
export * from "./EndedServiceEmployees.vue?vue&type=script&lang=js"
import style0 from "./EndedServiceEmployees.vue?vue&type=style&index=0&id=560e50ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560e50ab",
  null
  
)

export default component.exports